// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607300134/js/" + chunkId + "." + {"44":"54fc92bb","225":"b495a468","481":"fcebbbe4","486":"0645e260","770":"97ddfc98"}[chunkId] + ".0.6703144600746103.chunk.js";
};